var exports = {
  "w": "layoutToggleFormControl__Yq9srC",
};

module.exports = exports;
